import { dataStaging } from 'core/environments/env.staging';
import { dataStagingWin } from 'core/environments/env.stagingwin';
import { dataProduction } from 'core/environments/env.production';
import { dataDevelopment } from 'core/environments/env.development';
import { dataDevelopment1 } from 'core/environments/env.development1';
import { dataDevelopment2 } from 'core/environments/env.development2';
import { dataDevelopment3 } from 'core/environments/env.development3';
import { dataDevelopment4 } from 'core/environments/env.development4';
import { dataDevelopment5 } from 'core/environments/env.development5';
import { dataMirror } from 'core/environments/env.mirror';
import { dataPartner } from 'core/environments/env.partner';

export const LoadConfig = () => {
    const currentUrl = window?.location?.host;

    switch (currentUrl) {
        case 'portaldocliente-stg.ituran.com.br':
            return dataStaging;
        case 'portaldocliente.ituran.com.br':
            return dataProduction;
        case 'portaldocliente.homolog.ituran.com.br':
            return dataStagingWin;
        case 'portaldocliente-dev1.ituran.com.br':
            return dataDevelopment1;
        case 'portaldocliente-dev2.ituran.com.br':
            return dataDevelopment2;
        case 'portaldocliente-dev3.ituran.com.br':
            return dataDevelopment3;
        case 'portaldocliente-dev4.ituran.com.br':
            return dataDevelopment4;
        case 'portaldocliente-dev5.ituran.com.br':
            return dataDevelopment5;
        case 'portaldocliente-mir.ituran.com.br':
            return dataMirror;
        case 'portaldocliente-par.ituran.com.br':
            return dataPartner;
        default:
            return dataDevelopment;
    }
}